var previousWidth = $(window).width();
function adjustLayout() {
  $(".poschange-wrap").each(function () {
    var $box = $(this);
    var $flex = $box.find(".poschange");
    var $description = $box.find(".poschange-target");
    var $base = $flex.find(".poschange-flag");
    if ($(window).width() <= 1000) {
      if ($description.parent().hasClass("poschange")) return;
      //console.log('1000px以下に切り替わりました');
      $description.insertAfter($flex);
    } else {
      if ($description.parent().hasClass("poschange")) return;
      //console.log('1000px以上に切り替わりました');
      $description.appendTo($base);
    }
  });
}
adjustLayout();

$(window).on('resize', function () {
  var currentWidth = $(window).width();
  if ((previousWidth > 1000 && currentWidth <= 1000) || (previousWidth <= 1000 && currentWidth > 1000)) {
    adjustLayout();
  }
  previousWidth = currentWidth;
});


